import React, { useState } from 'react'
import { Hamburger } from '../../svgs'
import './external-links.scss'

const ExLink = ({ title, href }: { title: string; href: string }) => (
  <li>
    <a href={href} target="_blank" rel="noreferrer">
      {title}
    </a>
  </li>
)

export const ExternalLinks = ({ toggleSm = false }) => {
  const [navOpen, setNavOpen] = useState<boolean>(false)

  const toggleNav = () => setNavOpen((prevState) => !prevState)

  return (
    <div className="external-links">
      {toggleSm && (
        <button aria-controls="navbar" className="external-links__toggle" onClick={toggleNav}>
          <Hamburger />
        </button>
      )}

      <ul
        className={navOpen ? 'external-links__links--open' : undefined}
        data-testid="external-links"
      >
        <ExLink title="Trust Center" href="https://www.contrastsecurity.com/trust-center" />
        <ExLink
          title="Privacy"
          href="https://www.contrastsecurity.com/privacy-matters#privacy-policy"
        />
        <ExLink title="Support" href="https://support.contrastsecurity.com/hc/en-us" />
        <ExLink title="Release News" href="https://docs.contrastsecurity.com/en/release.html" />
        <ExLink title="Documentation" href="https://docs.contrastsecurity.com/index.html" />
      </ul>
    </div>
  )
}
